import { API_URL } from 'src/config/environment'
import apiCreator from '../api-creator'

type GetPresignedS3UploadAltaLinkResponse = {
  url: string;
}

export async function getPresignedS3UploadAltaLink(
  filename: string,
  abortSignal: AbortSignal,
): Promise<GetPresignedS3UploadAltaLinkResponse> {
  return apiCreator
    .get<GetPresignedS3UploadAltaLinkResponse>(
      `${API_URL.SCIFINDER}/get-upload-alta-url`,
      {
        params: {
          filename: filename,
        },
        signal: abortSignal,
      },
    )
    .then(({ data }) => data)
}
